module.exports = __webpack_public_path__ + "static/media/canais-newmobile.1efdccdc.jpg";